var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"aria-hidden":_vm.hidden,"color":_vm.color}},[_c('use',{attrs:{"xlink:href":_vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }